import React from "react";
import "./home.css";
import Social from "./Social";
import Data from "./Data";
import CV from "../../assets/hopemadzicv.pdf";
import ScrollDown from "./ScrollDown";
const Home = () => {
  return (
    <section className="home section" id="home">
      <div className="home__container container grid">
        <div className="home__content grid">
          <Social />
          <div className="home__img"></div>
          <Data />
        </div>
        <ScrollDown/>
        {/* <div className="home__hero">
          <div className="home__hero-left">
            <span className="home__hero-line"></span>
            <h1 className="home__hero-title">
              I design resilient <br />
              <strong>Cloud systems</strong> For production workloads

            </h1>
          </div>

          <div className="home__hero-right">
            <p>
              A cloud focused software engineer with hands on experience
              designing, deploying, and operating secure and scalable systems. I
              work with AWS, Azure, infrastructure as code, and distributed
              architectures to help teams ship reliable products faster.
            </p>

            <a download="" href={CV} className="home__hero-btn">
              Download CV
            </a>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default Home;
